// extracted by mini-css-extract-plugin
module.exports = {"Main":"Home_Main__2RMJO","Logo":"Home_Logo__2_Mtq","Container":"Home_Container__23TwT","Sliders":"Home_Sliders__HnsWL","Actions":"Home_Actions__22KaP","Play":"Home_Play__2EYaJ"};